import * as React from "react";

import * as DTO from "../../interfaces";
import { PlayersListWithBranch } from "@/components/Lists/PlayerBranchList";

import "./styles.scss";

interface OwnProps {
  selectedPlayers?: number[];

  parentResource?: string;
  disabled?: boolean;
  onChange: (selectedPlayers: number[]) => void;
  onPlayersLoaded?: (players: DTO.PlayerWithBranch[]) => void;
}

type Props = OwnProps;

const PlayerPostingFC: React.FC<Props> = ({ selectedPlayers = [], onChange, onPlayersLoaded }) => {
  const eligibilityCriteria = "include";
  React.useEffect(() => {
    onChange(selectedPlayers);
  }, [eligibilityCriteria]);

  return (
    <PlayersListWithBranch
      queryKey="subscribedPlayersByTag"
      selectedPlayers={selectedPlayers}
      onPlayersLoaded={onPlayersLoaded}
      onChangeSelectedPlayer={(playerIds: number[], checked: boolean) => {
        let newSelected: number[];
        if (checked) {
          newSelected = [...selectedPlayers, ...playerIds];
        } else {
          newSelected = selectedPlayers.filter(pId => {
            return !playerIds.includes(pId);
          });
        }
        onChange(newSelected);
      }}
    />
  );
};

export const PlayersPosting = PlayerPostingFC;
